import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '@/components/ui/Typography/Body/Text';
const sizes = {
    md: {
        companyNameSize: 'md',
        departmentSize: 'sm',
    },
    sm: {
        companyNameSize: 'sm',
        departmentSize: 'sm',
    },
};
export const RfpProfessionalCompanyNameText = (props) => {
    const { className, companyName, companyNameClassName, department, departmentClassName, size = 'md', } = props;
    return (_jsxs("span", Object.assign({ className: className }, { children: [_jsx(Text, Object.assign({ className: companyNameClassName, color: 'base', isBold: true, size: sizes[size].companyNameSize, tagName: 'span' }, { children: companyName })), department && (_jsxs(Text, Object.assign({ className: departmentClassName, color: 'base', size: sizes[size].departmentSize, tagName: 'span' }, { children: ["\uFF08", department, "\uFF09"] })))] })));
};
